(function () {
  var ATTR_KEY = '生年月日';
  var BLOCK_CLASS = 'is-age-blocked';
  var saveTimer = null;

  function pad(v) {
    return String(v).padStart(2, '0');
  }

  function calcAge(y, m, d) {
    var today = new Date();
    if (y < 1900 || y > today.getFullYear()) return null;

    var birth = new Date(y, m - 1, d);
    if (birth.getFullYear() !== y || birth.getMonth() !== m - 1 || birth.getDate() !== d) {
      return null;
    }
    if (birth > today) return null;

    var age = today.getFullYear() - y;
    var beforeBirthday =
      today.getMonth() < m - 1 ||
      (today.getMonth() === m - 1 && today.getDate() < d);
    if (beforeBirthday) age--;
    return age;
  }

  function getValues(root) {
    var y = root.querySelector('[data-birth="year"]');
    var m = root.querySelector('[data-birth="month"]');
    var d = root.querySelector('[data-birth="day"]');
    return {
      year: y ? parseInt(y.value, 10) : NaN,
      month: m ? parseInt(m.value, 10) : NaN,
      day: d ? parseInt(d.value, 10) : NaN
    };
  }

    function saveAttribute(value, age) {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var body = { attributes: {} };
      body.attributes[ATTR_KEY] = value;
      body.attributes['年齢'] = String(age);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      }).catch(function (e) {
        console.error('年齢確認情報の保存に失敗しました', e);
      });
    }, 600);
  }

    function toggleCheckout(blocked) {
    var targets = document.querySelectorAll(
      '[name="checkout"], .checkout-buttons a.btn, .checkout-buttons a[href*="/checkout"]'
    );
    Array.prototype.forEach.call(targets, function (el) {
      el.classList.toggle(BLOCK_CLASS, blocked);
      if (blocked) {
        el.setAttribute('aria-disabled', 'true');
      } else {
        el.removeAttribute('aria-disabled');
      }
      if (el.tagName === 'BUTTON') el.disabled = blocked;
    });

    // 動的決済ボタン（Shop Pay / Apple Pay など）
    var extra = document.querySelector('.additional-checkout-buttons');
    if (extra) {
      extra.classList.toggle(BLOCK_CLASS, blocked);
    }
  }

  // 他フォームの入力値も同期させる（ドロワーとカートページが同時に存在する場合）
  function syncOthers(source, v) {
    var roots = document.querySelectorAll('age-verification');
    Array.prototype.forEach.call(roots, function (root) {
      if (root === source) return;
      var y = root.querySelector('[data-birth="year"]');
      var m = root.querySelector('[data-birth="month"]');
      var d = root.querySelector('[data-birth="day"]');
      if (y) y.value = v.year;
      if (m) m.value = pad(v.month);
      if (d) d.value = pad(v.day);
    });
  }

  function validate(root, showError) {
    var minAge = parseInt(root.dataset.minAge || '20', 10);
    var v = getValues(root);
    var errorEl = root.querySelector('[data-age-error]');

    // 未入力は「未確認」として購入不可。ただしエラー文は出さない
    if (isNaN(v.year) || isNaN(v.month) || isNaN(v.day)) {
      if (errorEl) errorEl.hidden = true;
      toggleCheckout(true);
      return;
    }

    var age = calcAge(v.year, v.month, v.day);
    var ok = age !== null && age >= minAge;

    if (errorEl) errorEl.hidden = !(showError && !ok);
    toggleCheckout(!ok);

    if (ok) {
      syncOthers(root, v);
      saveAttribute(v.year + '-' + pad(v.month) + '-' + pad(v.day), age);
    }
  }

  function validateAll(showError) {
    var roots = document.querySelectorAll('age-verification');
    if (!roots.length) {
      toggleCheckout(false);
      return;
    }
    Array.prototype.forEach.call(roots, function (root) {
      validate(root, showError);
    });
  }

  // --- 年フィールドの整形（IME経由の全角入力対策）。キャプチャ段階で先に処理する
  document.addEventListener(
    'input',
    function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('[data-birth="year"]')) return;

      var cleaned = el.value.replace(/[^0-9]/g, '').slice(0, 4);
      if (cleaned !== el.value) {
        el.value = cleaned;
      }
    },
    true
  );

  // --- 入力中の再検証（エラー文は出さない）
  document.addEventListener('input', function (e) {
    var root = e.target.closest && e.target.closest('age-verification');
    if (root) validate(root, false);
  });

  // --- 確定時の検証（エラー文を出す）
  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest('age-verification');
    if (root) validate(root, true);
  });

  // --- 無効状態のボタンクリックを止める
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest && e.target.closest('.' + BLOCK_CLASS);
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();

      var root = document.querySelector('age-verification');
      if (root) {
        validate(root, true);
        var first = root.querySelector('[data-birth="year"]');
        if (first) first.focus();
      }
    },
    true
  );

  // --- 初期化とカート更新後の再判定
  function init() {
    validateAll(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('on:cart:change', init);
  document.addEventListener('on:cart:add', init);
  document.addEventListener('on:line-item:change', init);
})();